import React, { Component } from 'react'
import Container from '../common/application_container'

import { getUser } from '../../actions/session';


class MainReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),

        }

    }

    componentDidMount() {

    }



    render() {

        return (
            <Container title="Report" icon="fa fa-bars">
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',padding:'20px'}}>

                </div>
            </Container>
        )
    }
}
export default MainReport